import React from 'react';
// import logo from './res/IMG_1293.jpg';
import logo from './res/IMG_1295.jpg'
import logo2 from './res/madison.jpg'

import ReactGA from 'react-ga';
import Link from "./Link/Link"
import './Home.css';


ReactGA.initialize('UA-127647347-3', {
  debug: false
});

// export NODE_OPTIONS=--openssl-legacy-provider


ReactGA.pageview(window.location.pathname + window.location.search);

class Home extends React.Component {

  constructor(props) {
    super(props)
    this.viewResume = this.viewResume.bind(this);
    this.toggleProfile = this.toggleProfile.bind(this);
    this.state = {
      colorAccent: "gray",
      revealed: false
    }
  }

  componentDidMount() {}

  onClick(event) {
    var text = event.target.innerText || event.target.textContent;
    ReactGA.event({
      category: 'User',
      action: text
    });
  }

  onClickPaper(event, paperName) {
    ReactGA.event({
      category: 'User',
      action: paperName
    });
  }

  viewResume() {
    ReactGA.event({
      category: 'User',
      action: 'Clicked View Resume'
    });
  }

  toggleProfile() {
    this.setState(prevState => ({ revealed: !prevState.revealed }));
  }

  render() {

    return (
      <div className="Home">

        <div className="padding"></div>

        <header className="container">

          <div className="left">
            <div
              className={"profile-photo" + (this.state.revealed ? " revealed" : "")}
              onClick={this.toggleProfile}
            >
              <img className="profile" src={logo2} alt="" />
              <img className="profile-hover" src={logo} alt="" />
            </div>

            <div className="name-email-box">
              <p className="name">Sreehari Rammohan</p>
            </div>

          </div>

          <div className="right">
            <p>
            I'm a CS PhD student at Columbia University advised by <Link onClick={this.onClick} link="https://www.cs.columbia.edu/~vondrick/" target="_blank" color={this.state.colorAccent} hover="hoverable">Carl Vondrick</Link> in New York City.
            </p>

            <p>My research interests are in visual reasoning and embodiment.</p>

            <p>Before, I did my undergrad at Brown University where I studied Applied Math and CS advised primarily by <Link onClick={this.onClick} link="https://cs.brown.edu/people/gdk/" target="_blank" color={this.state.colorAccent} hover="hoverable">George Konidaris</Link>.</p>
            
            <p>I grew up in the Bay Area.</p>

            <p>[first name] [last name] [at] gmail [dot] com</p>

            <p>
              <strong>Select Publications:</strong>
              <br />

              <div>
                <p className="publication_title">
                LookThere! Sparse Vision by Reinforced Selection
                  <ul className="publication_ul">
                      <li>Sreehari Rammohan*, Yousef Yassin*, Anthony Fuller, Junfeng Wen, Carl Vondrick, Evan Shelhamer</li>
                      <li>NeurIPS 2026</li>
                      <li className="indentedLi">view <Link onClick={(event) => this.onClickPaper(event, "LookThere paper")} link={"https://arxiv.org/abs/2609.04698"} target="_blank" color={this.state.colorAccent} hover={"hoverable"}>paper</Link></li>
                  </ul>
                </p>
                <img className="publication_image" src={process.env.PUBLIC_URL + "/papers/lookthere-teaser.png"} alt="LookThere teaser figure" />
              </div>

              <div>
                <p className="publication_title">
                Attending on Attention (A<sup>2</sup>): Smaller Self-Supervised ViTs Localize Better Than Larger Ones
                  <ul className="publication_ul">
                      <li>Sreehari Rammohan, Huy Ha, Carl Vondrick</li>
                      <li>NeurIPS 2026</li>
                      <li className="indentedLi">view <Link onClick={(event) => this.onClickPaper(event, "Attending on Attention paper")} link={"https://arxiv.org/abs/2606.03148"} target="_blank" color={this.state.colorAccent} hover={"hoverable"}>paper</Link></li>
                  </ul>
                </p>
                <img className="publication_image" src={process.env.PUBLIC_URL + "/papers/a2-teaser.png"} alt="A² teaser figure" />
              </div>

              <div>
                <p className="publication_title">
                Robot Critics that Sweat the Small Stuff
                  <ul className="publication_ul">
                      <li>Sruthi Sudhakar, Junbang Liang, Sreehari Rammohan, Pavel Tokmakov, Richard Zemel, Carl Vondrick</li>
                      <li>In submission</li>
                      <li className="indentedLi">view <Link onClick={(event) => this.onClickPaper(event, "Robot Critics that Sweat the Small Stuff")} link={"https://arxiv.org/abs/2606.21572"} target="_blank" color={this.state.colorAccent} hover={"hoverable"}>paper</Link>, <Link onClick={(event) => this.onClickPaper(event, "Robot Critics website")} link={"https://robocritic.cs.columbia.edu/"} target="_blank" color={this.state.colorAccent} hover={"hoverable"}>website</Link></li>
                  </ul>
                </p>
                <img className="publication_image" src={process.env.PUBLIC_URL + "/papers/robocritic-teaser.png"} alt="Robot Critics that Sweat the Small Stuff teaser figure" />
              </div>

              <div>
                <p className="publication_title">
                Composable Interaction Primitives: A Structured Policy Class for Efficiently Learning Sustained-Contact Manipulation Skills
                  <ul className="publication_ul">
                      <li>Ben Abbatematteo, Eric Rosen, Skye Thompson, Mete Tuluhan Akbulut, Sreehari Rammohan, George Konidaris</li>
                      <li>ICRA 2024</li>
                      <li className="indentedLi">view <Link onClick={(event) => this.onClickPaper(event, "CIPs")} link={process.env.PUBLIC_URL + "/papers/cips_preprint.pdf"} target="_blank" color={this.state.colorAccent} hover={"hoverable"}>preprint</Link></li>
                  </ul>
                </p>
              </div>

              <div>
                <p className="publication_title">
                Hierarchical Empowerment: Towards Tractable Empowerment-Based Skill-Learning
                  <ul className="publication_ul">
                      <li>Andrew Levy, Sreehari Rammohan, Alessandro Allievi, Scott Niekum, George Konidaris</li>
                      <li>NeurIPS 2023 Workshop on Goal-Conditioned Reinforcement Learning</li>
                      <li className="indentedLi">view <Link onClick={(event) => this.onClickPaper(event, "Empowerement")} link={"https://arxiv.org/abs/2307.02728"} target="_blank" color={this.state.colorAccent} hover={"hoverable"}>paper</Link></li>
                  </ul>
                </p>
              </div>

              <div>
                <p className="publication_title">
                Effectively Learning Initiation Sets in Hierarchical Reinforcement Learning
                  <ul className="publication_ul">
                      <li>Akhil Bagaria, Ben Abattamateo, Omer Gottesman, Sreehari Rammohan, George Konidaris</li>
                      <li>NeurIPS 2023</li>
                      <li className="indentedLi">view <Link onClick={(event) => this.onClickPaper(event, "Initiation Set Learning")} link={process.env.PUBLIC_URL + "/papers/initiation-set-learning-camera-ready.pdf"} target="_blank" color={this.state.colorAccent} hover={"hoverable"}>paper</Link></li>
                  </ul>
                </p>
              </div>

              <div>
                <p className="publication_title">
                Q-Functionals For Value-Based Continuous Control
                  <ul className="publication_ul">
                      <li>Sreehari Rammohan*, Bowen He*, Sam Lobel*, Shangqun Yu, George Konidaris</li>
                      <li>AAAI 2023</li>
                      <li className="indentedLi">view  conference <Link onClick={(event) => this.onClickPaper(event, "Q-Functionals AAAI Paper")} link={process.env.PUBLIC_URL + "/papers/q-functionals-aaai-camera-ready.pdf"} target="_blank" color={this.state.colorAccent} hover={"hoverable"}>paper</Link></li>
                      <li>RLDM 2022: The Multi-disciplinary Conference on Reinforcement Learning and Decision Making</li>
                      <li className="indentedLi">view  workshop <Link onClick={(event) => this.onClickPaper(event, "Q-Functionals RLDM")} link={process.env.PUBLIC_URL + "/papers/q-functionals-rldm.pdf"} target="_blank" color={this.state.colorAccent} hover={"hoverable"}>paper</Link></li>
                  </ul>
                </p>
              </div>

              <div>
                <p className="publication_title">Rainbow RBF-DQN
                  <ul className="publication_ul">
                      <li>Sreehari Rammohan, Bowen He, Shangqun Yu, Eric Hsiung, Eric Rosen, George Konidaris</li>
                      <li>RLDM 2022: The Multi-disciplinary Conference on Reinforcement Learning and Decision Making</li>
                      <li className="indentedLi">view <Link onClick={(event) => this.onClickPaper(event, "Rainbow RBF-DQN RLDM")} link={process.env.PUBLIC_URL + "/papers/rainbow-rldm.pdf"} target="_blank" color={this.state.colorAccent} hover={"hoverable"}>abstract</Link>,
                      <Link onClick={(event) => this.onClickPaper(event, "Rainbow RBF-DQN Full Paper")} link={process.env.PUBLIC_URL + "/papers/rainbow-full.pdf"} target="_blank" color={this.state.colorAccent} hover={"hoverable"}>paper</Link>,
                      <Link onClick={(event) => this.onClickPaper(event, "Rainbow RBF-DQN Code")} link="https://github.com/SreehariRamMohan/rainbow_RBFDQN" target="_blank" color={this.state.colorAccent} hover={"hoverable"}> code </Link></li>
                  </ul>
                </p>
              </div>

              <div>
                <p className="publication_title">Does DQN really learn? Exploring adversarial training schemes in Pong
                  <ul className="publication_ul">
                      <li>Bowen He, Sreehari Rammohan, Jessica Forde, Michael Littman</li>
                      <li>RLDM 2022: The Multi-disciplinary Conference on Reinforcement Learning and Decision Making</li>
                      <li className="indentedLi">view  <Link onClick={(event) => this.onClickPaper(event, "Does DQN really learn? Exploring adversarial training schemes in Pong")} link={process.env.PUBLIC_URL + "/papers/pong-rldm.pdf"} target="_blank" color={this.state.colorAccent} hover={"hoverable"}>paper</Link></li>
                  </ul>
                </p>
              </div>

              <div>
                <p className="publication_title">Value-Based Reinforcement Learning for Continuous Control Robotic Manipulation in Multi-Task Sparse Reward Settings
                  <ul className="publication_ul">
                      <li>Sreehari Rammohan*, Shangqun Yu*, Bowen He*, Eric Hsiung*, Eric Rosen, Stefanie Tellex, George Konidaris</li>
                      <li>RSS 2021 Workshop on Advancing Artificial Intelligence and Manipulation for Robotics</li>
                      <li className="indentedLi">view <Link onClick={(event) => this.onClickPaper(event, "Continuous Control Robotic Manipulation in Multi-Task Sparse Reward Settings")} link="https://arxiv.org/abs/2107.13356" target="_blank" color={this.state.colorAccent} hover={"hoverable"}>paper</Link>, <Link onClick={this.onClick} link={process.env.PUBLIC_URL + "/RSS_Workshop_Poster.pdf"} target="_blank" color={this.state.colorAccent} hover={"hoverable"}>poster</Link></li>
                  </ul>
                </p>
              </div>

              <div>
                <p className="publication_title">Atrial Fibrillation Stratification Via Super-resolution Analysis of Fibrillatory Waves
                <ul className="publication_ul">
                    <li>Saumitra Mishra, Sreehari Rammohan, Khalid Z. Rajab, Gurpreet Dhillon, Pier Lambiase, Ross Hunter, Elaine Chew</li>
                    <li>CinC (Computing in Cardiology) 2019</li>
                    <li className="indentedLi">view <Link onClick={(event) => this.onClickPaper(event, "AF Stratification")} link="https://ieeexplore.ieee.org/abstract/document/9005797" target="_blank" color={this.state.colorAccent} hover={"hoverable"}>paper</Link></li>
                  </ul>
                </p>
              </div>

            </p>

            <div className="quoteBox">
            <p className="quoteText">"a torrent of him, and yet he is not diminished."</p> 
          </div>

          </div>

          

        </header>
      </div>
    );
  }
}

export default Home;
